<ng-container *ngIf="pageMoved; else defaultNotFound">
  <div class="moved-page">
    <section class="moved-content text-center">
      <p class="moved-code">404</p>
      <h1 class="moved-title">{{ 'NOT_FOUND_MOVED_MESSAGE' | translate }}</h1>
      <p class="moved-info">{{ 'NOT_FOUND_MOVED_INFO' | translate }}</p>

      <a class="lg-button moved-cta" [href]="faqUrl" target="_blank" rel="noopener">
        {{ 'NOT_FOUND_MOVED_FAQ_BUTTON' | translate }}
      </a>

      <p class="moved-home">
        <a class="blue-text-underline" [routerLink]="homeUrl">{{ 'NOT_FOUND_MOVED_HOME_LINK' | translate }}</a>
      </p>

      <p class="moved-contact" [innerHTML]="'NOT_FOUND_MOVED_CONTACT' | translate : { email: contactEmail }"></p>
    </section>
  </div>
</ng-container>

<ng-template #defaultNotFound>
  <div class="jumbotron vertical-center">
    <div class="text-center m-auto">
      <h1>Oops!</h1>
      <h2>404 {{ 'NOT_FOUND_MESSAGE' | translate }}</h2>
      <p>{{ 'NOT_FOUND_MESSAGE' | translate }}</p>

      <button type="button" class="lg-button" (click)="goHome()">{{ 'NOT_FOUND_HOME_BUTTON' | translate }}</button>
    </div>
  </div>
</ng-template>
